export default __webpack_public_path__ + "f4bdd85a576812f553ec3cfea8b1a2b5.woff2";